'use es6';

import React from 'react';
import { upgradeProductToTrialIds } from 'self-service-api/constants/Trials';
import TrialActivationButton from 'ui-addon-upgrades/_core/trial/activation/TrialActivationButton';

var updateUpgradeData = function updateUpgradeData(props) {
  var _props$upgradeData = props.upgradeData,
      app = _props$upgradeData.app,
      screen = _props$upgradeData.screen,
      uniqueId = _props$upgradeData.uniqueId;
  var isScreenUrlPath = screen.split('/').length > 1;
  var source = isScreenUrlPath ? uniqueId // Special case for UMS modals (uniqueId === upgradeKey)
  : app + "-" + screen + "-trial-button-" + uniqueId;
  return Object.assign({}, props, {
    upgradeData: Object.assign({}, props.upgradeData, {
      source: source,
      trialId: upgradeProductToTrialIds[props.upgradeData.upgradeProduct] || null
    })
  });
};

var UITrialActivationButton = function UITrialActivationButton(props) {
  return React.createElement(TrialActivationButton, updateUpgradeData(props));
};

export default UITrialActivationButton;